module.exports = __webpack_public_path__ + "static/media/Fiberglass-350x210.1a111c87.png";